module.exports = "pegasus_template/assets/background-patterns/fall-pets-theme.jpg";